import { useCallback, useEffect, useState } from "react";
import { BellRing, CheckCircle2 } from "lucide-react";
import { disableWebPush, enableWebPush, webPushStatus } from "../lib/pushClient";
import { useI18n } from "../lib/i18n";

export default function PlayerPushSettings() {
  const { t } = useI18n();
  const [state, setState] = useState({ status: "loading" });
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setState(await webPushStatus()); }
    catch { setState({ status: "error" }); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const enable = async () => {
    setBusy(true);
    try { setState(await enableWebPush()); }
    catch { setState({ status: "error" }); }
    finally { setBusy(false); }
  };
  const disable = async () => {
    setBusy(true);
    try { setState(await disableWebPush()); }
    catch { setState({ status: "error" }); }
    finally { setBusy(false); }
  };

  const copy = {
    loading: t("pushStatusLoading"),
    home_screen_required: t("pushHomeScreenRequired"),
    unsupported: t("pushUnsupported"),
    server_unavailable: t("pushUnavailable"),
    denied: t("pushDenied"),
    inactive: t("pushInactive"),
    active: t("pushActive"),
    error: t("pushError"),
  }[state.status] || t("pushInactive");

  return <div className="pc-account-section" data-testid="player-push-settings">
    <div className="flex items-start gap-3">
      <span className="w-10 h-10 rounded-xl grid place-items-center shrink-0" style={{ background: "var(--pc-cyan-dim)", color: "var(--pc-cyan)" }}>
        {state.status === "active" ? <CheckCircle2 size={19} /> : <BellRing size={19} />}
      </span>
      <div className="min-w-0 flex-1">
        <p className="text-sm mt-1 leading-relaxed" style={{ color: "var(--pc-muted)" }}>{copy}</p>
        {state.status === "home_screen_required" && <p className="text-xs mt-2 leading-relaxed" style={{ color: "var(--pc-cyan)" }}>{t("pushHomeScreenSteps")}</p>}
      </div>
    </div>
    {state.status === "inactive" && <button type="button" disabled={busy} onClick={enable} className="pc-btn pc-btn-primary w-full mt-4" data-testid="enable-push">{busy ? t("loading") : t("pushEnable")}</button>}
    {state.status === "active" && <button type="button" disabled={busy} onClick={disable} className="pc-btn pc-btn-ghost w-full mt-4" data-testid="disable-push">{busy ? t("loading") : t("pushDisable")}</button>}
    {state.status === "error" && <button type="button" disabled={busy} onClick={load} className="pc-btn pc-btn-ghost w-full mt-4">{t("retry")}</button>}
  </div>;
}
